import React, { Component, Context } from "react";
import clsx from "clsx";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import Form from "../../laco-common/forms/render";
import DataUtils from "../../laco-common/helpers/data-utils";
import { FirebaseContext } from "../../laco-common/firebase/context";
import { UIStyleProps } from "../ui/UIComponents";
import { IForm } from "../../laco-common";
import { CustomValidator } from "../../laco-common/base/form-validation";
import { IFirebaseContext } from "../../laco-common/base/firebase";
import "./FormWidget.scss";

export type FormWidgetProps = {
	formId?: string;
	form?: IForm;
	standalone?: boolean;
	isNested?: boolean;
	btnText?: string;
	successMsg?: string;
	values?: { [key: string]: any };
	disableFields?: { [key: string]: boolean };
	omitContactFields?: boolean;
	addContactFieldsNameOnly?: boolean;
	onFormSubmit?: (formId: string, values: any, formConfig: IForm, userPayload?, originalValues?) => Promise<any>;
	customValidators?: { [key: string]: CustomValidator | CustomValidator[] };
	footerBtnContent?: React.ReactNode;
	submitBoth?: boolean;
};

class FormWidget extends Component<IAuthProps & FormWidgetProps & UIStyleProps> {
	static contextType: Context<IFirebaseContext> = FirebaseContext;

	componentDidMount() {
		if (this.props.authContext.userPayload) {
			DataUtils.loadTenant({
				...this.context,
				userPayload: this.props.authContext.userPayload,
			});
		}
	}

	render() {
		return (
			<div className={clsx(this.props.standalone && "bg-gray1", this.props.className)}>
				<div
					className={clsx(
						"laco-common-form-container",
						this.props.standalone && "container form-standalone",
						!this.props.isNested && "section-padding"
					)}
				>
					<Form
						formId={Array.isArray(this.props.formId) ? this.props.formId[0] : this.props.formId}
						form={this.props.form}
						btnText={this.props.btnText || this.props.form?.btnText}
						successMsg={this.props.successMsg || this.props.form?.successMsg}
						userPayload={this.props.authContext.userPayload}
						addContactFields={!this.props.omitContactFields}
						addContactFieldsNameOnly={this.props.addContactFieldsNameOnly}
						customProps={{ showIcon: false }}
						withAsterisks={true}
						asteriskTemplate={<span className="text-primary pl-1">*</span>}
						values={this.props.values}
						disableFields={this.props.disableFields}
						onSubmitOverride={
							this.props.onFormSubmit
								? (formId: string, values: any, formConfig: IForm, userPayload, originalValues) =>
										this.props.onFormSubmit(formId, values, formConfig, userPayload, originalValues)
								: undefined
						}
						submitBoth={this.props.submitBoth}
						customValidators={this.props.customValidators}
						footerBtnContent={this.props.footerBtnContent}
					/>
				</div>
			</div>
		);
	}
}

export default withAuth(FormWidget, true);
